import '../css/info-card.css';
import {
	ALLASHARC_COLOUR,
	ARROW_NEXT,
	ARROW_PREV,
	getDateString,
	INTENSITY_ICON,
	INTENSITY_ICON_ACTIVE,
	MANOVEREZO_COLOUR,
	ROMBUSZ
} from './info.details';
import {
	INTENSITIES,
	MARTIAL_COLOURS,
	MARTIAL_ICON_FALLBACK,
	MARTIAL_ICONS,
	MARTIAL_LEVELS,
	MARTIAL_STRUCTURE,
	parseDate
} from './details';
// import 'overlayscrollbars/overlayscrollbars.css';
// import { OverlayScrollbars } from 'overlayscrollbars';

export default class InfoCards {
	constructor() {
		this.cardsWrapper = document.getElementById('info-cards');
		this.currentCardIndex = 0;
		this.scrollbars = [];
	}

	init() {
		//
	}

	setupArrows() {
		this.prevArrow = document.getElementById('info-card-arrow-prev');
		this.nextArrow = document.getElementById('info-card-arrow-next');
		this.pagination = document.getElementById('info-card-pagination');
		if (!this.prevArrow || !this.nextArrow) return;
		this.prevArrow.onclick = () => {
			this.onCardArrowClick(true);
			this.updatePagination();
		};
		this.nextArrow.onclick = () => {
			this.onCardArrowClick(false);
			this.updatePagination();
		};
		this.updateArrowsVisibility();
		this.updatePagination();
	}

	updatePagination() {
		if (!this.pagination || !this.cardsWrapper) return;
		const count = this.cardsWrapper.querySelectorAll('.info-card').length;
		this.pagination.textContent = `${this.currentCardIndex + 1}/${count}`;
	}

	updateArrowsVisibility() {
		if (!this.cardsWrapper || !this.prevArrow || !this.nextArrow) return;

		const cards = this.cardsWrapper.querySelectorAll('.info-card');
		const show = cards.length > 1;
		const display = show ? 'flex' : 'none';

		this.prevArrow.style.display = display;
		this.nextArrow.style.display = display;
	}

	onCardArrowClick(isPrev) {
		if (!this.cardsWrapper) return;

		const cards = this.cardsWrapper.querySelectorAll('.info-card');
		const count = cards.length;
		if (count <= 1) return;

		let newIndex = this.currentCardIndex + (isPrev ? -1 : 1);
		this.toggleCards(newIndex);
	}

	update(relevantItems) {
		if (!relevantItems) return;
		this.updateCards(relevantItems);
		let firstMartialEventIndex = 0;
		for (let i = 0; i < relevantItems.length; i++) {
			const item = relevantItems[i];
			if (item.is_bomb) continue;
			firstMartialEventIndex = i;
			break;
		}
		this.toggleCards(firstMartialEventIndex || 0);
		this.setupArrows();
	}

	toggleCards(index = 0) {
		if (!this.cardsWrapper) return;

		const cards = this.cardsWrapper.querySelectorAll('.info-card');
		const dots = document.querySelectorAll('.info-timeline-dot');
		const count = cards.length;
		if (!count) {
			this.currentCardIndex = 0;
			return;
		}

		if (index < 0) index = count - 1;
		if (index >= count) index = 0;

		cards.forEach((card, i) => {
			card.classList.toggle('active', i === index);
		});

		dots.forEach((dot, i) => {
			dot.classList.toggle('active', i === index);
		});

		this.currentCardIndex = index;
	}

	updateCards(items = []) {
		if (!this.cardsWrapper) return;
		if (!items.length) {
			this.cardsWrapper.innerHTML = '';
			this.currentCardIndex = 0;
			return;
		}

		this.cardsWrapper.innerHTML = '';
		const fragment = new DocumentFragment();

		if (items.length > 1) {
			fragment.appendChild(this.getArrows());
		}

		let index = 0;
		for (const item of items) {
			const card = this.getCard(item, index);
			fragment.appendChild(card);
			index++;
		}

		this.cardsWrapper.appendChild(fragment);
		this.currentCardIndex = 0;

		this.initScrollbars();
	}

	destroyScrollbars() {
		if (!this.scrollbars || !this.scrollbars.length) return;

		for (const instance of this.scrollbars) {
			try {
				if (instance && typeof instance.destroy === 'function') {
					instance.destroy();
				}
			} catch (e) {
				// optional: console.warn('Failed to destroy OverlayScrollbars instance', e);
			}
		}
		this.scrollbars = [];
	}

	initScrollbars() {
		if (!this.cardsWrapper) return;

		// this.destroyScrollbars();

		const cols = this.cardsWrapper.querySelectorAll('.info-card-col-content');
		if (!cols.length) return;

		// this.destroyScrollbars();

		// setTimeout(() => {
		// 	cols.forEach((el) => {
		// 		const instance = OverlayScrollbars(el, {
		// 			overflow: {
		// 				x: 'hidden',
		// 				y: 'scroll'
		// 			}
		// 		});
		// 		if (instance) {
		// 			this.scrollbars.push(instance);
		// 		}
		// 	});
		// });
	}

	getArrows() {
		const arrowsWrapper = document.createElement('div');
		arrowsWrapper.id = 'info-card-arrows';
		const arrowPrev = document.createElement('div');
		arrowPrev.classList.add('info-card-arrow');
		arrowPrev.id = 'info-card-arrow-prev';
		arrowPrev.innerHTML = ARROW_PREV;
		const pagination = document.createElement('div');
		pagination.id = 'info-card-pagination';
		const arrowNext = document.createElement('div');
		arrowNext.classList.add('info-card-arrow');
		arrowNext.id = 'info-card-arrow-next';
		arrowNext.innerHTML = ARROW_NEXT;
		arrowsWrapper.appendChild(arrowPrev);
		arrowsWrapper.appendChild(pagination);
		arrowsWrapper.appendChild(arrowNext);
		return arrowsWrapper;
	}

	getCard(item, index) {
		const card = document.createElement('div');
		card.classList.add('info-card');
		if (item.is_bomb) card.classList.add('info-card-bomb');
		card.dataset.index = index.toString();
		const fragment = new DocumentFragment();
		if (item.is_bomb) {
			const leftCol = this.getBombCardLeft(item);
			const rightCol = this.getBombCardRight(item);
			fragment.appendChild(leftCol);
			fragment.appendChild(rightCol);
		} else {
			const leftCol = this.getCardSide(item);
			const midCol = this.getCardMiddle(item);
			const rightCol = this.getCardSide(item, true);
			fragment.appendChild(leftCol);
			fragment.appendChild(midCol);
			fragment.appendChild(rightCol);
		}
		card.appendChild(fragment);
		return card;
	}

	getBombCardLeft(item) {
		const div = document.createElement('div');
		div.classList.add('info-card-bomb-col');
		div.classList.add('info-card-bomb-col-left');
		const img = document.createElement('img');
		img.src = item.is_green ? 'bomb-green.png' : 'bomb-red.png';
		div.appendChild(img);
		return div;
	}

	getBombCardRight(item) {
		const div = document.createElement('div');
		div.classList.add('info-card-bomb-col');
		div.classList.add('info-card-bomb-col-right');
		const title = document.createElement('div');
		title.textContent = 'Hadműveleti légitámadás időpontja és az okozott veszteség/kár';
		title.classList.add('info-card-bomb-title');
		const date = document.createElement('div');
		date.textContent = getDateString(new Date(item.date)) || 'N/A';
		date.classList.add('info-card-bomb-date');
		const text = document.createElement('div');
		text.textContent = item.text || 'N/A';
		text.classList.add('info-card-bomb-text');
		div.appendChild(title);
		div.appendChild(date);
		div.appendChild(text);
		return div;
	}

	getCardMiddle(item) {
		const itemDate = item['A birtokváltás időpontja(i)'] || null;
		const dateString = itemDate == null ? 'N/A' : getDateString(parseDate(itemDate));
		const middleCol = document.createElement('div');
		middleCol.classList.add('info-card-middle');
		middleCol.classList.add('info-card-col');
		const dateElement = document.createElement('div');
		dateElement.classList.add('info-card-date');
		dateElement.textContent = dateString;
		const modeElement = this.getModeElement(item);
		const intensityElement = this.getIntensityElement(item);
		const bottomRow = document.createElement('div');
		bottomRow.classList.add('info-card-middle-bottom-row');
		const tanks = this.getTanksElement(item);
		bottomRow.appendChild(tanks);
		const fragment = new DocumentFragment();
		fragment.appendChild(dateElement);
		fragment.appendChild(modeElement);
		fragment.appendChild(document.createElement('hr'));
		fragment.appendChild(intensityElement);
		fragment.appendChild(document.createElement('hr'));
		fragment.appendChild(bottomRow);
		middleCol.appendChild(fragment);
		return middleCol;
	}

	getModeElement(item) {
		const mode = item['A harctevékenység jellege'] || 'N/A';
		const modeElement = document.createElement('div');
		modeElement.classList.add('info-card-mode');
		const modeLabel = document.createElement('div');
		modeLabel.classList.add('info-card-mode-label');
		modeLabel.textContent = mode;
		const modeIcon = document.createElement('div');
		modeIcon.classList.add('info-card-mode-icon');
		modeIcon.style.background = mode.includes('manőver') ? MANOVEREZO_COLOUR : ALLASHARC_COLOUR;
		modeElement.appendChild(modeLabel);
		modeElement.appendChild(modeIcon);
		return modeElement;
	}

	getIntensityElement(item) {
		const fragment = new DocumentFragment();
		const intensity = item['A harctevékenység átlagos intenzitása']?.trim() || '';
		const intensityIndex = INTENSITIES.indexOf(intensity);
		const intensityTitle = document.createElement('div');
		intensityTitle.classList.add('info-card-intensity-title');
		intensityTitle.textContent = 'Harcok intenzitása';
		fragment.appendChild(intensityTitle);
		const intensityElement = document.createElement('div');
		intensityElement.classList.add('info-card-intensity');
		for (let i = 0; i < INTENSITIES.length; i++) {
			const intensityIcon = document.createElement('div');
			intensityIcon.classList.add('info-card-intensity-icon');
			intensityIcon.innerHTML = i <= intensityIndex ? INTENSITY_ICON_ACTIVE : INTENSITY_ICON;
			intensityElement.appendChild(intensityIcon);
		}
		fragment.appendChild(intensityElement);
		const intensityDescription = document.createElement('div');
		intensityDescription.classList.add('info-card-intensity-description');
		intensityDescription.textContent = intensity || 'N/A';
		fragment.appendChild(intensityDescription);
		return fragment;
	}

	getTanksElement(item) {
		const wrapper = document.createElement('div');
		wrapper.classList.add('info-card-tanks');
		const title = document.createElement('div');
		title.classList.add('info-card-tanks-title');
		title.innerHTML = 'Páncélosok száma';
		const numTanks = item['Páncélosok alkalmazása']?.split(' ')[0] || 0;
		const tanks = document.createElement('div');
		tanks.classList.add('info-card-tanks-sign');
		tanks.innerHTML = ROMBUSZ;
		const tanksLabel = document.createElement('div');
		tanksLabel.classList.add('info-card-tanks-label');
		tanksLabel.textContent = numTanks;
		tanks.appendChild(tanksLabel);
		wrapper.appendChild(title);
		wrapper.appendChild(tanks);
		return wrapper;
	}

	getCardSide(item, isRight = false) {
		const rawData = (isRight ? item['A támadó katonai erők'] : item['A védő katonai erők ']) || '';
		const data = (isRight ? item.tamado_keys : item.vedo_keys) || [];
		const numbers = (isRight ? item.tamado_numbers : item.vedo_numbers) || [];
		const col = document.createElement('div');
		col.classList.add(`info-card-${isRight ? 'right' : 'left'}`);
		col.classList.add('info-card-col');
		const title = document.createElement('div');
		title.classList.add('info-card-col-title');
		title.innerHTML = isRight ? 'Támadó erők' : 'Védő erők';
		col.appendChild(title);
		const colContent = document.createElement('div');
		colContent.classList.add('info-card-col-content');
		colContent.dataset.raw = rawData;
		colContent.title = rawData;
		colContent.appendChild(this.getCardSideSigns(data, numbers));
		col.appendChild(colContent);
		return col;
	}

	getCardSideSigns(data, numbers) {
		const signs = document.createElement('div');
		signs.classList.add('info-card-signs');
		const fragment = new DocumentFragment();

		if (data.toString() === '') {
			const div = document.createElement('div');
			div.classList.add('info-card-signs-na');
			div.textContent = 'nincs adat';
			signs.appendChild(div);
			return signs;
		}

		const levelPossibilites = Object.keys(MARTIAL_LEVELS);
		const nationalityPossibilites = MARTIAL_STRUCTURE.nemzetiség;
		for (let i = 0; i < data.length; i++) {
			const keyGroup = data[i];
			if (!Array.isArray(keyGroup) || !keyGroup.length) continue;

			const presentLevel = keyGroup.find((key) => levelPossibilites.includes(key)) || null;
			const number = numbers && numbers[i] != null && !isNaN(numbers[i]) ? String(numbers[i]) : '';
			const nationality = keyGroup.find((key) => nationalityPossibilites.includes(key)) || null;
			const colourValue = nationality ? MARTIAL_COLOURS[nationality] || '#fff' : '#fff';

			const iconWrapper = document.createElement('div');
			iconWrapper.classList.add('info-card-sign');
			if (keyGroup.includes('parent')) iconWrapper.classList.add('info-card-sign-parent');
			if (keyGroup.includes('child')) iconWrapper.classList.add('info-card-sign-child');
			iconWrapper.style.setProperty('--nationality-colour', colourValue || '#fff');
			iconWrapper.appendChild(this.getSignNumber(number));

			const col = document.createElement('div');
			col.classList.add('info-card-sign-col');
			col.appendChild(this.getSignLevel(presentLevel || ''));

			let iconCount = 0;
			for (const key of keyGroup) {
				const icon = MARTIAL_ICONS[key];
				if (!icon) continue;
				const iconContainer = document.createElement('div');
				iconContainer.innerHTML = icon;
				col.appendChild(iconContainer);
				iconCount++;
			}
			if (iconCount === 0 && MARTIAL_ICON_FALLBACK) {
				const iconContainer = document.createElement('div');
				iconContainer.innerHTML = MARTIAL_ICON_FALLBACK;
				col.appendChild(iconContainer);
			}

			iconWrapper.appendChild(col);
			const tag = document.createElement('div');
			tag.classList.add('info-card-tag');
			tag.textContent = this.getSignTagText(keyGroup);
			iconWrapper.appendChild(tag);
			fragment.appendChild(iconWrapper);
			setTimeout(() => {
				this.applySvgColour(iconWrapper, colourValue);
			});
		}

		signs.appendChild(fragment);
		return signs;
	}

	getSignTagText(keyGroup) {
		const tags = [];
		const nationality = keyGroup.find((a) => MARTIAL_STRUCTURE.nemzetiség.includes(a)) || '';
		const mode = keyGroup.find((a) => Object.keys(MARTIAL_ICONS).includes(a)) || '';
		const level = keyGroup.find((a) => Object.keys(MARTIAL_LEVELS).includes(a)) || '';
		if (nationality) tags.push(nationality);
		if (mode) tags.push(mode);
		if (level) tags.push(level);
		return tags.length ? tags.join(' ') : 'N/A';
	}

	applySvgColour(root, colour) {
		if (!root || !colour) return;

		const svgs = root.querySelectorAll('svg');
		const updateNode = (node) => {
			const stroke = node.getAttribute('stroke');
			if (stroke && stroke.toLowerCase() !== 'none') {
				node.setAttribute('stroke', colour);
			}
			const fill = node.getAttribute('fill');
			if (fill && fill.toLowerCase() !== 'none') {
				node.setAttribute('fill', colour);
			}
		};

		svgs.forEach((svg) => {
			updateNode(svg);
			const nodes = svg.querySelectorAll('*');
			nodes.forEach(updateNode);
		});
	}

	getSignNumber(number) {
		const numberElement = document.createElement('div');
		numberElement.classList.add('info-card-sign-number');
		if (number) {
			numberElement.innerHTML = `${number}.`;
		} else {
			numberElement.innerHTML = ``;
		}

		return numberElement;
	}

	getSignLevel(presentLevel) {
		const levelElement = document.createElement('div');
		levelElement.classList.add('info-card-sign-level');
		levelElement.innerHTML = MARTIAL_LEVELS[presentLevel] || '';
		return levelElement;
	}
}
